import { makeAutoObservable } from 'mobx';

export default class DeviceState {
	public isMobile: boolean = false;

	constructor() {
		makeAutoObservable(this);

		this.detectIsMobile();
		window.addEventListener('resize', this.detectIsMobile.bind(this));
	}

	detectIsMobile() {
		let isMobile =
			window.document.documentElement.clientWidth > 0 &&
			window.document.documentElement.clientWidth < 768;
		this.updateIsMobile(isMobile);
	}

	updateIsMobile(isMobile: boolean) {
		this.isMobile = isMobile;
	}
}
